import React, { useState } from 'react';
import Abas from '../../components/Abas';
import MotivoOfertaTab from './MotivoOfertaTab';
import StatusOfertaTab from './StatusOfertaTab';
import './styles.scss';

const Configuracoes = () => {
    const [abaAtiva, setAbaAtiva] = useState(1);

    const abas = [
        { id: 1, nome: 'Motivo da Oferta' },
        { id: 2, nome: 'Status da Oferta' }
    ];

    const handleMudarAba = (abaId) => {
        setAbaAtiva(abaId);
    };

    return (
        <div className="configuracoes-container">
            <Abas 
                abas={abas} 
                active={abaAtiva} 
                action={handleMudarAba}
            />

            <div className="conteudo-abas">
                {abaAtiva === 1 && (
                    <MotivoOfertaTab />
                )}
                {abaAtiva === 2 && (
                    <StatusOfertaTab />
                )}
            </div>


        </div>
    );
};

export default Configuracoes;
